import { setObservabilityUser } from './observability/user';

window._ = require('lodash');

try {
    require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// 凍結ユーザーの403エラーハンドリング
window.axios.interceptors.response.use(
    function (response) {
        // /api/user/get/me のレスポンスで観測テレメトリ（Datadog RUM）に
        // ログインユーザーを付与する。legacy には /me の choke point が無いため、
        // ここで一点配線する（React 側の useFetchGetMeResponse と同等）。
        try {
            const url = response.config && response.config.url;
            if (
                typeof url === 'string' &&
                url.includes('/api/user/get/me') &&
                response.data &&
                response.data.user
            ) {
                setObservabilityUser(response.data.user);
            }
        } catch (e) {
            // 観測系の失敗で業務ロジックを止めない
        }
        return response;
    },
    function (error) {
        if (error.response && error.response.status === 403) {
            const errorData = error.response.data;
            // 凍結エラーの場合は凍結ページにリダイレクト
            if (errorData && errorData.error_code === 'USER_SUSPENDED') {
                window.location.href = '/suspended';
                return Promise.reject(error);
            }
        }
        return Promise.reject(error);
    }
);

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
